import { Button, Drawer, Form, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";

const CreateAttributeDrawer = ({ visible, setVisible, token }) => {
  const [form] = useForm();

  const createNewTypeAttribute = (values) => {
    axios
      .post(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes?token=${token}`,
        values
      )
      .then(() => {
        setVisible(false);
        form.resetFields();
      })
      .catch((e) => console.log(e));
  };
  return (
    <Drawer
      open={visible}
      placement="right"
      onClose={() => setVisible(false)}
      title="Создание атрибута"
    >
      <Form form={form} layout="vertical" onFinish={createNewTypeAttribute}>
        <Form.Item label="Название" name="name">
          <Input />
        </Form.Item>
        <Form.Item label="*alias" name="alias">
          <Input />
        </Form.Item>
        <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
          Создать
        </Button>
      </Form>
    </Drawer>
  );
};

export default CreateAttributeDrawer;
